var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuCart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnssvgjs: "http://svgjs.com/svgjs",
    width: 40,
    height: 40,
    x: 0,
    y: 0,
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m30.242 25.478a10.3 10.3 0 0 0 -7.693-9.006 2.785 2.785 0 1 0 -5.1 0 10.377 10.377 0 0 0 -1.088.353v-10.115a1 1 0 0 0 -1-1h-2.147v-3.71a1 1 0 0 0 -1.414-.908l-10.219 4.708a1 1 0 0 0 -.581.91v21.29a1 1 0 0 0 1 1h7v1a1 1 0 0 0 1 1h20a1 1 0 0 0 1-1v-3.57a.987.987 0 0 0 -.758-.952zm-2.012-.048h-16.461a7.932 7.932 0 0 1 .231-1.168 8.284 8.284 0 0 1 7.986-6.121h.018.02a8.3 8.3 0 0 1 8.206 7.289zm-9.016-10.073a.786.786 0 1 1 .8.783h-.023a.785.785 0 0 1 -.777-.783zm-8-9.647h-4.658l4.658-2.147zm-8.214 21.29v-19.29h9.2.019s.013 0 .02 0h2.121v10.127a10.354 10.354 0 0 0 -4.294 5.9 10.055 10.055 0 0 0 -.294 1.74.985.985 0 0 0 -.772.953v.57zm26 2h-18v-1.57h18z",
    fill: "#283159",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.143 17.929h3.928a1 1 0 1 0 0-2h-3.928a1 1 0 0 0 0 2z",
    fill: "#283159",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.071 20.071a1 1 0 0 0 -1-1h-3.928a1 1 0 0 0 0 2h3.928a1 1 0 0 0 1-1z",
    fill: "#283159",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.143 14.786h7.071a1 1 0 0 0 1-1v-3.143a1 1 0 0 0 -1-1h-7.071a1 1 0 0 0 -1 1v3.143a1 1 0 0 0 1 1zm1-3.143h5.071v1.143h-5.071z",
    fill: "#283159",
    "data-original": "#000000",
    className: ""
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuCart);
export default __webpack_public_path__ + "static/media/menu-cart.5410821c767b7c5bc4c69dd35604bc9d.svg";
export { ForwardRef as ReactComponent };